import { doc, DocumentReference } from 'firebase/firestore';
import isEmpty from 'lodash/isEmpty';
import { docData } from 'rxfire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';

export type Activity = 'analyze' | 'export';

export interface ICurrentActivitySetting {
  activityId: Activity;
}

/**
 * @description hot observable of the users current activity setting `/userProfiles/${user.id}/settings/currentActivity`
 */
export const currentActivitySettingProvider =
  new BehaviorSubject<ICurrentActivitySetting>(null);

/**
 * @description start observing metric settings
 */
authenticatedUserProvider()
  .pipe(
    switchMap((user: IUser): Observable<ICurrentActivitySetting> => {
      return docData<ICurrentActivitySetting>(
        doc(
          user.services.firestore,
          `userProfiles/${user.id}/settings/currentActivity`
        ) as DocumentReference<ICurrentActivitySetting>
      ).pipe(
        map((setting: ICurrentActivitySetting): ICurrentActivitySetting => {
          if (!isEmpty(setting)) return setting;
          return { activityId: 'analyze' };
        })
      );
    })
  )
  .subscribe(currentActivitySettingProvider);
